import styled, { keyframes } from 'styled-components';
import { reportsViewportFrameCss } from 'pages/ReportsPage/ReportsPage.styled';

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const DataLockedOverlay = styled.div<{ x: number; isPendingApproval: boolean }>`
  ${reportsViewportFrameCss}
  z-index: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(240, 240, 245, 0.78);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
`;

export const DataLockedCard = styled.div`
  background: ${({ theme }) => theme.colors.White};
  border: 1px solid #c9ccec;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(45, 43, 85, 0.16);
  padding: 48px 56px;
  text-align: center;
  max-width: 560px;
  margin: 0 24px;
  transform: translateY(-40px);
`;

export const DataLockedSpinner = styled.div`
  width: 48px;
  height: 48px;
  margin: 0 auto 24px;
  border: 4px solid #e0dfe8;
  border-top-color: #4a4580;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

export const DataLockedTitle = styled.h2`
  ${({ theme }) => theme.fonts.PoppinsBold};
  font-size: 24px;
  color: #2d2b55;
  margin: 0 0 12px;
`;

export const DataLockedBody = styled.p`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 16px;
  color: #6b6b80;
  line-height: 1.55;
  margin: 0;
`;
